const mapGooglePayContactAddress = (paymentData, type = "shippingAddress") => {
  const billingAddress = paymentData.paymentMethodData.info?.billingAddress;
  const [firstName = "", ...lastNameParts] = (billingAddress?.name ?? "").split(" ");
  const lastName = lastNameParts.join(" ").trim() ?? "";
  const isShippingAddress = type === "shippingAddress";
  const address = isShippingAddress ? paymentData.shippingAddress : billingAddress;
  return {
    firstName,
    lastName,
    streetName: address?.address1 ?? "",
    postalCode: address?.postalCode ?? "",
    city: address?.locality ?? "",
    countryCode: address?.countryCode ?? "",
    ...billingAddress?.phoneNumber ? { phone: billingAddress?.phoneNumber } : {},
    ...paymentData.email ? { email: paymentData.email } : {},
    ...address?.administrativeArea ? { region: address?.administrativeArea } : {},
    ...address?.address2 ? { additionalAddressInfo: address.address2 } : {}
  };
};
export {
  mapGooglePayContactAddress
};
//# sourceMappingURL=google-pay-contact-address.js.map
